import * as React from 'react';
import { SVGProps } from 'react';

const IconGradientsSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 1H8v8.382l-2 1v8.153l3 2V23h2v-3.535l-3-2v-5.847l2-1V1ZM14 1v6h3v7.28l-3 1V23h2v-6.28l3-1V5h-3V1h-2Z" />
  </svg>
);
export default IconGradientsSizeM;
